import * as React from 'react';
import * as TabsPrimitive from '@radix-ui/react-tabs';
import { cn } from '@/lib/utils';

const Tabs = TabsPrimitive.Root;

const TabsList = React.forwardRef<
  React.ElementRef<typeof TabsPrimitive.List>,
  React.ComponentPropsWithoutRef<typeof TabsPrimitive.List>
>(({ className, ...props }, ref) => (
  <TabsPrimitive.List
    ref={ref}
    className={cn(
      'dls-inline-flex dls-h-9 dls-items-center dls-justify-center dls-gap-2 dls-rounded-md dls-bg-neutral-contrast dls-p-1 dls-text-muted-foreground',
      className
    )}
    {...props}
  />
));
TabsList.displayName = TabsPrimitive.List.displayName;

const TabsTrigger = React.forwardRef<
  React.ElementRef<typeof TabsPrimitive.Trigger>,
  React.ComponentPropsWithoutRef<typeof TabsPrimitive.Trigger>
>(({ className, ...props }, ref) => (
  <TabsPrimitive.Trigger
    ref={ref}
    className={cn(
      'dls-inline-flex dls-items-center dls-justify-center dls-whitespace-nowrap dls-rounded-md dls-px-4 dls-py-2 dls-text-sm dls-font-semibold dls-ring-offset-background dls-transition-all focus-visible:dls-outline-none focus-visible:dls-ring-2 focus-visible:dls-ring-neutral focus-visible:dls-ring-offset-2 disabled:dls-pointer-events-none disabled:dls-opacity-50 hover:dls-bg-neutral-quarternary data-[state=active]:dls-bg-background data-[state=active]:dls-text-foreground data-[state=active]:dls-shadow-10',
      className
    )}
    {...props}
  />
));
TabsTrigger.displayName = TabsPrimitive.Trigger.displayName;

const TabsContent = React.forwardRef<
  React.ElementRef<typeof TabsPrimitive.Content>,
  React.ComponentPropsWithoutRef<typeof TabsPrimitive.Content>
>(({ className, ...props }, ref) => (
  <TabsPrimitive.Content
    ref={ref}
    className={cn(
      'dls-mt-2 dls-ring-offset-background focus-visible:dls-outline-none focus-visible:dls-ring-2 focus-visible:dls-ring-neutral focus-visible:dls-ring-offset-2',
      className
    )}
    {...props}
  />
));
TabsContent.displayName = TabsPrimitive.Content.displayName;

const TabsListUnderline = React.forwardRef<
  React.ElementRef<typeof TabsPrimitive.List>,
  React.ComponentPropsWithoutRef<typeof TabsPrimitive.List>
>(({ className, ...props }, ref) => (
  <TabsPrimitive.List
    ref={ref}
    className={cn(
      'dls-inline-flex dls-items-center dls-gap-0 dls-border-b dls-border-border dls-text-muted-foreground',
      className
    )}
    {...props}
  />
));
TabsListUnderline.displayName = 'TabsListUnderline';

const TabsTriggerUnderline = React.forwardRef<
  React.ElementRef<typeof TabsPrimitive.Trigger>,
  React.ComponentPropsWithoutRef<typeof TabsPrimitive.Trigger>
>(({ className, ...props }, ref) => (
  <TabsPrimitive.Trigger
    ref={ref}
    className={cn(
      'dls-inline-flex dls-items-center dls-justify-center dls-whitespace-nowrap dls-px-5 dls-py-2.5 dls-text-sm dls-font-medium -dls-mb-px dls-border-b-2 dls-border-transparent dls-transition-all hover:dls-text-foreground disabled:dls-pointer-events-none disabled:dls-opacity-50 data-[state=active]:dls-text-neeve-primary data-[state=active]:dls-border-neeve-primary data-[state=active]:dls-font-semibold',
      className
    )}
    {...props}
  />
));
TabsTriggerUnderline.displayName = 'TabsTriggerUnderline';

export { Tabs, TabsList, TabsTrigger, TabsContent, TabsListUnderline, TabsTriggerUnderline };
